import { Component, OnInit } from '@angular/core';
import { AppInformationService, AuthService, BrewersUnitOfWork } from 'app/core/core.module';
import { default as validationEngine } from 'devextreme/ui/validation_engine';
import moment from 'moment';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    standalone: false,
    selector: 'app-project-dialog',
    templateUrl: './project-dialog.component.html',
    styleUrls: ['./project-dialog.component.scss'],
})
export class ProjectDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    mode: string;
    entity: any;
    customer: any;

    minDate: Date;
    errorAction = 'saving';
    validationGroup = 'mainValidationGroup';
    isToastVisible = false;
    processing = false;

    constructor(public modalRef: BsModalRef, private uow: BrewersUnitOfWork, private appInfo: AppInformationService, private auth: AuthService) {}

    async ngOnInit() {
        this.processing = true;

        if (this.mode === 'add') {
            this.entity = this.uow.projects.createEntity({
                customerId: this.customer.id,
                created: new Date(),
                createdBy: this.auth.currentUser.userName
            }) as any;
        }



        this.minDate = moment(new Date()).add(-34, 'days').toDate();
        this.processing = false;
    }

    hasChanges() {
        return this.uow.hasChanges();
    }

    onNumberLostFocus(e: any) {
        if (this.entity.duration > 0) {
            const duration = this.roundDuration(this.entity.duration);
            this.entity.duration = duration;
        }
    }

    roundDuration(duration: number) {
        return Math.ceil(duration * 4) / 4;
    }

    async save() {
        this.appInfo.pleaseWaitShow();
        if (!this.validate()) {
            this.appInfo.pleaseWaitHide();
            return;
        }
        if (this.entity.workCodeId === -1) this.entity.workCodeId = null;

        if (this.uow.hasChanges()) {
            this.entity.edited = new Date();
            this.entity.editedBy = this.auth.currentUser.userName;
            const notes = [] as any[];
            const now = moment(new Date()).format('MM/DD/YYYY h:mm:ss a');
            if (this.entity.notes) notes.push(this.entity.notes);
            notes.push(`${this.mode === 'add' ? 'Added ' : 'Edited '} ${now}`);
            this.entity.notes = notes.join('; ');
        }
        await this.uow.commit();

        this.appInfo.pleaseWaitHide();
        this.result.next({ success: true });
    }

    close() {
        this.uow.rollback();
        this.result.next({ success: false });
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig(this.validationGroup);
        if (groupConfig) {
            const result = validationEngine.validateGroup(this.validationGroup);
            if (!result.isValid) {
                let message = '';
                if (result.brokenRules)
                    result.brokenRules.forEach((brokenRule) => {
                        if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                    });
                this.appInfo.notifyToast(`Please fix errors before ${this.errorAction}.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }
}
